import styled from 'styled-components';
export const SwitchCircleStyled = styled.span `
  background-color: blue;
  border-radius: 50%;
  position: absolute;
  width: 24px;
  height: 24px;
  top: 50%;
  left: 3px;
  transform: translateY(-50%);
  transition: left 0.2s;
  z-index: 3;

  ::before {
    position: absolute;
    content: '';
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    background: linear-gradient(#ffffff, rgb(214, 227, 243, 0.46));
    border-radius: 50%;
    z-index: 2;
  }
  ::after {
    position: absolute;
    content: '';
    top: 0px;
    left: 0px;
    right: 0px;
    background: ${({ disabled }) => (disabled ? '#C6C8D2' : '#e3edf7')};
    bottom: 0px;
    border-radius: 50%;
    z-index: 3;
  }

  #drawIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1px;
    height: 8px;
    z-index: 4;
    border-radius: 2px;
    ${({ theme: { colors } }) => ` 
    transform: translate(-50%, -50%);
    border: 1px solid ${colors.gray700};
    background: ${colors.gray700};
    `}
  }

  ${({ small }) => small &&
    `
    height: 14px;
    width: 14px;
    top: 51%;
    transform: translateY(-56%);
    #drawIcon {
      transform: translate(-25%, -50%);
      height: 6px;
      width: 0px;
      border: 1px solid transparent;
    }
  `}

  ${({ checked, theme: { colors }, small, disabled }) => checked &&
    `
  left: ${small ? `calc(100% - 18px);` : `calc(100% - 27px);`}
  ::before {
    background: linear-gradient(#ffffff, rgb(214, 227, 243, 0.46));
  }
  ::after {
    background: ${disabled
        ? '#C6C8D2'
        : `linear-gradient(270deg, ${colors.blue500} 0%, ${colors.blue500} 39.9%, ${colors.lightBlue500} 100%);`}
  }
  #drawIcon {
    transform: translate(-25%, -50%);
    border: 1px solid ${disabled ? colors.gray700 : colors.gray100};
    background: ${disabled ? colors.gray700 : colors.gray100};
  }
  `}
`;
export const SwitchStyled = styled.button `
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff,
    2px 2px 4px 0px rgba(114, 142, 171, 0.1);
  width: 64px;
  height: 30px;
  border-radius: 100px;
  background: linear-gradient(#ffffff, rgb(214, 227, 243, 0.46));
  border: 0px solid transparent;
  position: relative;
  z-index: 1;

  ::before {
    position: absolute;
    content: '';
    top: 1px;
    left: 1px;
    bottom: 2px;
    right: 1px;
    background: #e3edf7;
    border-radius: 100px;
    z-index: -1;
  }

  ${({ small }) => small &&
    `
    width: 41px;
    height: 20px;
  `}

  ${({ checked }) => checked &&
    `
    box-shadow: none;
    background: #FFF;
    ::before {
        background: #FFF;
        box-shadow: 4px 4px 14px 0px #d9d9d9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
    }
    `}

  ${({ disabled }) => disabled &&
    `
    cursor: not-allowed;
    box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff,
    2px 2px 4px 0px rgba(114, 142, 171, 0.1);
    background: linear-gradient(#ffffff, rgb(214, 227, 243, 0.46));
    ::before {
        background: #5B5D71;
        box-shadow: none;
    }
    `}
`;
//# sourceMappingURL=styled.js.map